import { createFileRoute, Navigate, Outlet } from "@tanstack/react-router";
import { toast } from "sonner";
import { AppSidebar } from "@/components/app-sidebar";
import { Loader } from "@/components/Loader";
import { useAuth } from "@/components/providers/auth";
import { TeamProvider, useTeam } from "@/components/providers/team";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { consumeUnauthorizedRedirectToastSuppression } from "@/utils/auth-session";

export function AuthApp() {
	const auth = useAuth();
	const { loading } = useTeam();

	if (auth.isInitialLoading || loading) {
		return <Loader />;
	}

	if (!auth.isAuthenticated) {
		if (!consumeUnauthorizedRedirectToastSuppression()) {
			toast.error("You must be logged in to access this page", {
				description: "Please log in to continue",
			});
		}
		return <Navigate to="/auth/login" />;
	}

	return (
		<SidebarProvider>
			<AppSidebar />
			<SidebarInset>
				<Outlet />
			</SidebarInset>
		</SidebarProvider>
	);
}

export function Auth() {
	return (
		<TeamProvider>
			<AuthApp />
		</TeamProvider>
	);
}

/* istanbul ignore start -- TanStack Router file route registration */
export const Route = createFileRoute("/_authorized")({
	component: Auth,
});
/* istanbul ignore end */
